import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "database-view" }
const _hoisted_2 = { class: "database-view__header" }
const _hoisted_3 = { class: "database-view__control" }
const _hoisted_4 = { class: "database-view__body" }

import IconImport from "@/assets/icons/IconImport.vue";
import IconStars from "@/assets/icons/IconStars.vue";
import DatabaseTable from "@/components/modules/Database/DatabaseTable.vue";
import {useFilesStore} from "@/stores/files";
import {computed, onMounted, ref } from "vue";
import DatabaseToolbar from "@/components/modules/Database/DatabaseToolbar.vue";
import {storeToRefs} from "pinia";
import {useStore} from "@/stores";
import ForecastButton from "@/components/ui/buttons/ForecastButton.vue";
import FileReportView from "@/components/modules/FileReport/FileReportView.vue";
import {useReportStore} from "@/stores/report";
import GlobalLoader from "@/components/ui/loaders/GlobalLoader.vue";
import {FilesDataQuery, Region} from "@/types/files";


export default /*@__PURE__*/_defineComponent({
  __name: 'DatabaseView',
  setup(__props) {

const reportStore = useReportStore();
const filesStore = useFilesStore();
const mainStore = useStore();

onMounted(() => {
  loadFilesData();
});

// Используем реактивные данные из store
const {filesData} = storeToRefs(filesStore);
const {currentReport} = storeToRefs(reportStore);

// Флаг загрузки файлов.

const { isLoadingFilesData } = storeToRefs(filesStore);

const selectedRegionList = ref<Region[]>([]);

// Активный месяц и год
const { selectedMonth } = storeToRefs(filesStore);
const { selectedYear } = storeToRefs(filesStore);

// Выбранный округ и регион из store
const { selectedDistrictKey, selectedRegionKey } = storeToRefs(filesStore);

const filesList = computed(() => {
  if (!filesData.value || typeof filesData.value !== "object") {
    return [];
  }
  return filesData.value.results || [];
});

// Функция загрузки данных
const loadFilesData = async () => {
  try {
    const params: FilesDataQuery = {};

    // Список выбранных регионов.
    params.regions = selectedRegionList.value;

    // Выбранный месяц, год.
    if (selectedMonth.value !== "all") {
      params.month = selectedMonth.value;
    }
    params.year = selectedYear.value;

    // Фильтр по округу
    if (selectedDistrictKey.value) {
      params.federal_districts = selectedDistrictKey.value;
    }

    // Фильтр по региону
    if (selectedRegionKey.value) {
      params.regions = selectedRegionKey.value;
    }

    await filesStore.getFilesData(params);
  } catch (error) {
    console.error("Ошибка загрузки данных файлов:", error);
  }
};

// Значение строки поиска параметров
const paramsSearchQueryValue = ref("");

// Отображение модального окна отчета.
const isShowReportView = ref(false);

const toggleShowReportView = () => {
  isShowReportView.value = !isShowReportView.value;
};

const createdReportId = ref<string | null>(null);

// Функция создания отчета.
const createReport = async () => {
  isStartReportLoading.value = true;
  const createdReport = await reportStore.createReport(selectedYear.value);
  createdReportId.value = createdReport.id;
  toggleShowReportView();
  isStartReportLoading.value = false;
};

const approveReport = async () => {
  if (createdReportId.value) {
    isStartReportApprove.value = true;
    await reportStore.approveReport(createdReportId.value);
    await reportStore.exportReport(selectedYear.value);
  }
  isStartReportApprove.value = false;
};

// Состояние создания отчета.

const isStartReportApprove = ref(false);
const isStartReportLoading = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_ButtonRoundedSecondary = _resolveComponent("ButtonRoundedSecondary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "database-view__title" }, " База данных ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ButtonRoundedSecondary, {
          size: "large",
          onClick: createReport
        }, {
          default: _withCtx(() => [
            _createVNode(IconImport),
            _cache[7] || (_cache[7] = _createTextVNode(" Создать отчет ", -1))
          ]),
          _: 1
        }),
        _createVNode(ForecastButton, {
          disabled: !_unref(mainStore).forecastStatus || _unref(filesData)?.results.length === 0,
          active: _unref(mainStore).forecastStatusDisplay,
          size: "large",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(mainStore).toggleForecastStatusDisplay()))
        }, {
          default: _withCtx(() => [
            _createVNode(IconStars),
            _cache[8] || (_cache[8] = _createTextVNode(" Прогноз 2025 ", -1))
          ]),
          _: 1
        }, 8, ["disabled", "active"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(DatabaseToolbar, {
        "params-search-query": paramsSearchQueryValue.value,
        "onUpdate:paramsSearchQuery": _cache[1] || (_cache[1] = ($event: any) => ((paramsSearchQueryValue).value = $event)),
        "selected-regions": selectedRegionList.value,
        "onUpdate:selectedRegions": [
          _cache[2] || (_cache[2] = ($event: any) => ((selectedRegionList).value = $event)),
          loadFilesData
        ],
        "active-month": _unref(selectedMonth),
        "onUpdate:activeMonth": [
          _cache[3] || (_cache[3] = ($event: any) => (_isRef(selectedMonth) ? (selectedMonth).value = $event : null)),
          loadFilesData
        ],
        "active-year": _unref(selectedYear),
        "onUpdate:activeYear": [
          _cache[4] || (_cache[4] = ($event: any) => (_isRef(selectedYear) ? (selectedYear).value = $event : null)),
          loadFilesData
        ],
        "selected-district": _unref(selectedDistrictKey),
        "onUpdate:selectedDistrict": [
          _cache[5] || (_cache[5] = ($event: any) => (_isRef(selectedDistrictKey) ? (selectedDistrictKey).value = $event : null)),
          loadFilesData
        ],
        "selected-region": _unref(selectedRegionKey),
        "onUpdate:selectedRegion": [
          _cache[6] || (_cache[6] = ($event: any) => (_isRef(selectedRegionKey) ? (selectedRegionKey).value = $event : null)),
          loadFilesData
        ]
      }, null, 8, ["params-search-query", "selected-regions", "active-month", "active-year", "selected-district", "selected-region"]),
      _createVNode(DatabaseTable, {
        "selected-regions": selectedRegionList.value,
        "params-search-query": paramsSearchQueryValue.value,
        items: filesList.value,
        loading: _unref(isLoadingFilesData),
        "selected-district-key": _unref(selectedDistrictKey),
        "selected-region-key": _unref(selectedRegionKey)
      }, null, 8, ["selected-regions", "params-search-query", "items", "loading", "selected-district-key", "selected-region-key"])
    ]),
    (isShowReportView.value && _unref(currentReport))
      ? (_openBlock(), _createBlock(FileReportView, {
          key: 0,
          report: _unref(currentReport),
          "is-start-approve": isStartReportApprove.value,
          onApproveReport: approveReport,
          onHideReportView: toggleShowReportView
        }, null, 8, ["report", "is-start-approve"]))
      : _createCommentVNode("", true),
    (isStartReportLoading.value)
      ? (_openBlock(), _createBlock(GlobalLoader, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})